/*
  Powiększona galeria zdjęć produktu (lightbox).
  Markup: snippets/product-lightbox.liquid
  Otwierają go elementy z data-lightbox-trigger i data-index.
*/
(function () {
  if (window.__productLightboxInit) return;
  window.__productLightboxInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var lightbox = document.querySelector('[data-product-lightbox]');
    var dataEl = document.querySelector('[data-lightbox-images]');
    if (!lightbox || !dataEl) return;

    var images = [];
    try {
      images = JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      console.warn('Galeria produktu: nie udało się odczytać listy zdjęć', e);
      return;
    }
    if (!images.length) return;

    var imageEl = lightbox.querySelector('[data-lightbox-image]');
    var counterEl = lightbox.querySelector('[data-lightbox-counter]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');

    var currentIndex = 0;
    var lastFocused = null;

    function render() {
      var image = images[currentIndex];
      if (!image) return;
      imageEl.src = image.src;
      imageEl.alt = image.alt || '';
      if (counterEl) counterEl.textContent = currentIndex + 1 + ' / ' + images.length;
    }

    function preload(index) {
      var image = images[index];
      if (!image) return;
      var preloaded = new Image();
      preloaded.src = image.src;
    }

    function open(index) {
      currentIndex = Math.min(Math.max(index, 0), images.length - 1);
      lastFocused = document.activeElement;
      render();

      lightbox.hidden = false;
      lightbox.classList.remove('hidden');
      lightbox.classList.add('flex');
      document.body.classList.add('overflow-hidden');

      // pozwól przeglądarce złapać stan początkowy, żeby zadziałało przejście
      requestAnimationFrame(function () {
        lightbox.classList.remove('opacity-0');
      });

      if (closeBtn) closeBtn.focus();
      preload(currentIndex + 1);
      preload(currentIndex - 1);
    }

    function close() {
      lightbox.classList.add('opacity-0');
      document.body.classList.remove('overflow-hidden');

      window.setTimeout(function () {
        lightbox.classList.add('hidden');
        lightbox.classList.remove('flex');
        lightbox.hidden = true;
      }, 200);

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function step(delta) {
      if (images.length < 2) return;
      currentIndex = (currentIndex + delta + images.length) % images.length;
      render();
      preload(currentIndex + delta);
    }

    // otwieranie
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lightbox-trigger]');
      if (!trigger) return;
      event.preventDefault();
      open(parseInt(trigger.getAttribute('data-index'), 10) || 0);
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    // klik w tło zamyka, klik w samo zdjęcie nie
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowLeft') step(-1);
      else if (event.key === 'ArrowRight') step(1);
      else if (event.key === 'Tab') {
        // focus zostaje w oknie
        var focusable = lightbox.querySelectorAll('button');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    // swipe na telefonie
    var touchStartX = null;
    var touchStartY = null;

    lightbox.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var touch = event.changedTouches[0];
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      step(deltaX < 0 ? 1 : -1);
    }, { passive: true });
  });
})();
